exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rule-tooltip .el-tooltip__popper{max-width:600px;line-height:1.5}.rule-tooltip h4{margin:10px 0 5px;font-weight:700}.rule-tooltip h5{margin:8px 0 3px;font-weight:700}.rule-tooltip ul{margin:5px 0;padding-left:20px}.rule-tooltip li{margin-bottom:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37730ce3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/customer/Account.vue
// module id = 1902
// module chunks = 0